import { defineStore } from "pinia";

export const useorderList = defineStore("orderList", {
  state: () => {
    const startYear = 2026;
    const currentYear = new Date().getFullYear();
    const yearList = [];

    for (let year = currentYear; year >= startYear; year--) {
      yearList.push({
        label: `${year}`,
        value: year,
      });
    }

    return {
      pageNum: 1,
      searchGoods: "",
      searchStatus: 0,
      goodsUpdateTime: 1,
      goodsUpdateTimeList: [
        { label: "最近", value: 1 },
        ...yearList,
        { label: "已删除", value: "isDel" },
        // { label: "非显示商品", value: "isShow" },
        { label: "自定义打印", value: "isDiy" },
      ],
      isRepeict: false,

      // 收益账单
      earningUpdateTime: 1,
      earningUpdateTimeList: [
        { label: "最近", value: 1 },
        { label: "最近30天", value: 2 },
        { label: "2026年", value: 3 },
        { label: "自定义时间", value: 4 },
      ],
    };
  },
  getters: {},
  actions: {
    reset() {
      this.pageNum = 1;
      ((this.searchGoods = ""), (this.searchStatus = 0));
      this.goodsUpdateTime = 1;
      console.log("重置", this.pageNum);
    },
  },
});
